import ProductService from '../services/product.service';

export const product = {
  namespaced: true,
  state: {
    productList: [],
    activeProductList: [],
  },
  actions: {
    async getProductList({ commit }) {
      const resp = await ProductService.getProductList();
      if (resp.status === 200) {
        commit('SET_PRODUCT_LIST', resp.data);
      }
      return resp.status;
    },

    async getProductListPublic({ commit }) {
      const resp = await ProductService.getProductListPublic();
      if (resp.status === 200) {
        commit('SET_PRODUCT_LIST', resp.data);
      }
      return resp.status;
    },

    async getProductListActive({ commit }) {
      const resp = await ProductService.getActiveProductList();
      if (resp.status === 200) {
        commit('SET_ACTIVE_PRODUCT_LIST', resp.data);
      }
      return resp.status;
    },
    async createProduct(_, newProduct) {
      const resp = await ProductService.createProduct(newProduct);
      return resp.status;
    },
    async editProduct(_, currentProduct) {
      const resp = await ProductService.editProduct(currentProduct);
      return resp.status;
    },
    async deleteProduct(_, productId) {
      const resp = await ProductService.deleteProduct(productId);
      return resp.status;
    },
  },
  mutations: {
    SET_PRODUCT_LIST(state, productList) {
      state.productList = productList;
    },
    SET_ACTIVE_PRODUCT_LIST(state, activeProductList) {
      state.activeProductList = activeProductList;
    },
  },
};
